import api from './api';

// Benutzerliste wird von allen Betreuer-Feldern geteilt → einmal pro Anmeldung laden.
// Der Cache ist an das Token gebunden: nach einem Benutzer-/Mandantenwechsel ohne
// Neuladen der Seite dürfen nicht die Benutzer des vorherigen Mandanten erscheinen.
let usersPromise = null;
let usersToken = null;
let groupsPromise = null;
let groupsToken = null;

// Gruppen in den Rechte-Listen: „team:<team_type>“ (spiegelt backend/utils/access_rights.py)
export const TEAM_PREFIX = 'team:';

const accessRightsService = {
  // Aktive Benutzer des Mandanten (für Betreuer-Auswahl und Zugriffsrechte)
  getAssignableUsers: () => {
    const token = localStorage.getItem('token');
    if (!usersPromise || usersToken !== token) {
      usersToken = token;
      usersPromise = api.get('/users/assignable')
        .then((r) => r.data?.users || [])
        .catch((e) => { usersPromise = null; throw e; });
    }
    return usersPromise;
  },

  // Teams des Mandanten als Gruppen für die Zugriffsrechte (alphabetisch)
  getGroups: () => {
    const token = localStorage.getItem('token');
    if (!groupsPromise || groupsToken !== token) {
      groupsToken = token;
      groupsPromise = api.get('/teams')
        .then((r) => (r.data?.teams || [])
          .map((t) => ({ id: `${TEAM_PREFIX}${t.team_type}`, name: t.display_name || t.name || t.team_type }))
          .sort((a, b) => a.name.localeCompare(b.name, 'de')))
        .catch((e) => { groupsPromise = null; throw e; });
    }
    return groupsPromise;
  },

  // entity: 'projects' | 'addresses'
  save: async (entity, id, accessRights) => {
    const r = await api.put(`/${entity}/${id}/access-rights`, { access_rights: accessRights });
    return r.data?.access_rights;
  },
};

// Spiegelt backend/utils/access_rights.py: leere Liste = alle Benutzer, Admins dürfen alles
export function hasAccessRight(record, action, user) {
  if (!user) return false;
  if (user.role === 'admin' || user.is_superuser) return true;
  const list = record?.access_rights?.[action] || [];
  const ich = [user.id, ...(user.teams || []).map((t) => `${TEAM_PREFIX}${t}`)];
  return list.length === 0 || list.some((x) => ich.includes(x));
}

export function hasRestrictions(record) {
  const rights = record?.access_rights;
  return !!rights && typeof rights === 'object' && !Array.isArray(rights)
    && Object.values(rights).some((l) => Array.isArray(l) && l.length > 0);
}

export default accessRightsService;
